export const LOGIN_SUCCEED_SAGA = "LOGIN_SUCCEED_SAGA";
export const LOGIN_SUCCEED_REDUX = "LOGIN_SUCCEED_REDUX";
export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCEED = "LOGOUT_SUCCEED";
export const SET_USER = "SET_USER";
export const UPDATE_LOGOUT = "UPDATE_LOGOUT";
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";
export const UPDATE_SELECTED_LANGUAGE = "UPDATE_SELECTED_LANGUAGE";
export const OPEN_LOGIN_MODAL = "OPEN_LOGIN_MODAL";
export const CLOSE_LOGIN_MODAL = "CLOSE_LOGIN_MODAL";
export const FETCH_FAVORITES = "FETCH_FAVORITES";
export const FETCH_FAVORITES_SUCCESS = "FETCH_FAVORITES_SUCCESS";
export const FETCH_FAVORITES_FAILED = "FETCH_FAVORITES_FAILED";
export const FETCH_FAVORITES_FAILED_MAX_RETRIES = "FETCH_FAVORITES_FAILED_MAX_RETRIES";
export const ADD_REMOVE_FAVORITE = "ADD_REMOVE_FAVORITE";
export const COMPLETE_ADD_REMOVE_FAVORITE = "COMPLETE_ADD_REMOVE_FAVORITE";
